export const ALLOWED_CATEGORY_MEDIA_EXTENSION_TYPE = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/gif',
];

export const ALLOWED_CATEGORY_PUBLICATION_MEDIA_TYPES = ['image/jpeg', 'image/jpg', 'video/mp4'];

export const ALLOWED_CATEGORY_PUBLICATION_CAROUSEL_MEDIA_TYPES = ['image/jpeg', 'image/jpg'];
